import React,{useState,useEffect} from 'react'
import Author from 'components/detail/Author'
import Search from 'components/home/Search'
import Detail from 'components/detail/Detail'
import SearchContainer from 'components/SearchContainer'
import './style.css'
import { useParams } from 'react-router'
import { getForumDetail } from 'redux/actions/forum'
import { useDispatch,useSelector } from 'react-redux'
import ChevronRight from 'assets/icon/chevron-right.png'
import {Helmet} from "react-helmet";
export default function Index() {
    const dispatch = useDispatch()
    const reducer = useSelector(state => state.reducer)
    const persist = useSelector(state => state.persist)
    const [searchmodal, setsearchmodal] = useState(false)
    const [parent, setparent] = useState(null)
    let { id } = useParams();
    let {forum_detail}=reducer
    useEffect(() => {
        // if(forum_detail.parent===null){
            // getDetail()
        // }
        
    }, [persist.comment_sort])
    const getDetail=()=>{
        dispatch(getForumDetail(`/${id}/${persist.comment_sort}/1/20`))

    }
    return (
        <div>
           <Helmet>
                <meta charSet="utf-8" />
                <title>{forum_detail!==null?forum_detail.title:''} | QuBisa</title>
                <link rel="canonical" href={window.location} />
                <meta name="description" content={forum_detail!==null?forum_detail.text:''}></meta>
            </Helmet>
            <div className='layout-container'>
                {searchmodal&&<div onClick={()=>setsearchmodal(false)} className='backdrop-search'></div>}
                {searchmodal&&<SearchContainer/>}
                <div className='breadcrump '>
                    <a className='prev-breadcrump' href="/forum">Forum</a>
                    <img src={ChevronRight} alt="chevron"/>
                    <a className='current-breadcrump' href="#">Detail Diskusi</a>
                </div>
                <div className='home-grid'>
                    <div className='left-grid'>
                        <Author />
                    </div>
                    <div className='center-grid'>
                        <Detail  />
                    </div>
                    <div className='right-grid'>
                        <Search setsearchmodal={setsearchmodal} searchmodal={searchmodal}/>
                    </div>
                </div>
            </div>
            <br/><br/><br/>
        </div>
    )
}
